import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import DataCacheService from '@/shared/services/DataCacheService';
import EditableSelect from './EditableSelect';
var messages = defineMessages({
    SelectAValue: { id: 'SelectAValue', defaultMessage: 'Select a value' },
});
var EditableCompanySelect = function (_a) {
    var _b = _a.value, value = _b === void 0 ? null : _b, onChange = _a.onChange, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.readOnly, readOnly = _d === void 0 ? false : _d, placeholder = _a.placeholder, _e = _a.allCompanies, allCompanies = _e === void 0 ? false : _e;
    var intl = useIntl();
    var _f = useState([]), options = _f[0], setOptions = _f[1];
    useEffect(function () {
        var companies = (allCompanies
            ? DataCacheService.getAllCompanies()
            : DataCacheService.getCompanies())
            .map(function (x) { return ({ id: x.id, label: x.name }); })
            .sort(dynamicSort('label'));
        setOptions(companies);
    }, []);
    if (typeof placeholder === 'undefined')
        placeholder = intl.formatMessage(messages.SelectAValue);
    return (_jsx(EditableSelect, { value: value, options: options, onChange: onChange, required: required, readOnly: readOnly, placeholder: placeholder }));
};
export default EditableCompanySelect;
